<template>
  <router-link class="ej-card" :to="'/articles/' + article.slug + '/'">
    <div class="ej-card-media">
      <img
        v-if="article.thumbnail"
        :src="publicPath + article.thumbnail"
        :alt="article.thumbnailAlt || article.cardTitle || article.title"
        loading="lazy"
        decoding="async"
      />
      <div v-else class="ej-card-ph">Thumbnail</div>
    </div>
    <span class="ej-card-kicker">{{ article.category }}</span>
    <h3 class="ej-card-title">{{ article.cardTitle || article.title }}</h3>
    <p class="ej-card-excerpt">{{ article.excerpt }}</p>
  </router-link>
</template>

<script>
// One card, used by the /articles listing, the home Articles teaser, and the
// template's related section — so there is a single source for card markup+style.
// Styles are scoped: the landing's global `h3`/`p`/`span`/`img` rules would
// otherwise leak in and blow up the type sizes.
export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // Thumbnails live in landing/public/, served from the build's publicPath.
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style lang="scss" scoped>
$accent: #e95557;
$ink: #09100e;
$muted: #6b7175;

.ej-card {
  display: block;
  color: inherit;
  text-decoration: none;
}

.ej-card-media {
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 14px;
  background: #e4e5e8;
  border: 1px solid #e7e8ea;
  box-sizing: border-box;
}
.ej-card-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}
.ej-card:hover .ej-card-media img {
  transform: scale(1.04);
}
.ej-card-ph {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: repeating-linear-gradient(45deg, #dcdee1 0 12px, #e4e5e8 12px 24px);
  color: #9aa0a6;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ej-card-kicker {
  display: block;
  color: $accent;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.ej-card-title {
  color: $ink;
  font-size: 1.15rem;
  line-height: 1.3;
  font-weight: 500;
  letter-spacing: normal;
  margin: 6px 0;
  transition: color 0.15s ease;
}
.ej-card:hover .ej-card-title {
  color: $accent;
}
.ej-card-excerpt {
  color: $muted;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: normal;
  margin: 0;
}
</style>
